<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :custom-class="
      mode === 'forgotPassword'
        ? 'auth-dialog forgot-password-dialog'
        : 'auth-dialog'
    "
    :show-close="false"
    :close-on-click-modal="false"
    @close="handleClose"
    @open="initializeForm"
  >
    <transition name="fade" mode="out-in">
      <div :key="mode" class="auth-container">
        <!-- ==================== 登录面板 (当 mode 为 'login' 时显示) ==================== -->
        <template v-if="mode === 'login'">
          <!-- 左侧：登录表单 -->
          <div class="form-panel">
            <div class="yanding-logo">
              <img src="@/assets/yanding-logo.png" alt="YANDING Logo" />
            </div>
            <div class="form-wrapper">
              <h2 class="title">{{ $t("login.title") }}</h2>
              <el-form
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules"
                class="login-form"
                @submit.native.prevent="handleLogin"
              >
                <el-form-item prop="phone">
                  <el-input
                    v-model="loginForm.phone"
                    type="text"
                    :placeholder="
                      isChineseLocale ? $t('register.phone') : $t('login.email')
                    "
                    autocomplete="off"
                    :prefix-icon="
                      isChineseLocale
                        ? 'el-icon-mobile-phone'
                        : 'el-icon-message'
                    "
                    class="custom-input"
                    @input="clearPasswordError"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="password"
                  :class="{ 'is-error': !!serverErrorMessage }"
                >
                  <el-input
                    v-model="loginForm.password"
                    type="password"
                    :placeholder="$t('login.pwd')"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                    class="custom-input"
                    @input="clearPasswordError"
                  ></el-input>
                  <div
                    v-if="serverErrorMessage"
                    class="el-form-item__error manual-error"
                  >
                    {{ serverErrorMessage }}
                  </div>
                </el-form-item>
              </el-form>
              <div class="forgot-password-wrapper">
                <a
                  href="#"
                  class="forgot-password"
                  @click.prevent="mode = 'forgotPassword'"
                >
                  {{ $t("login.forgotPWD") }}
                </a>
              </div>
              <el-button
                type="primary"
                class="action-btn signin-btn"
                @click="handleLogin"
                :loading="isLoggingIn"
                >{{ $t("login.signin") }}</el-button
              >
            </div>
          </div>
          <!-- 右侧：欢迎与注册入口 -->
          <div class="welcome-panel">
            <i class="el-icon-close close-btn" @click="handleClose"></i>
            <div class="welcome-content">
              <h2 class="welcome-title">{{ $t("login.hello_title") }}</h2>
              <p class="welcome-text">{{ $t("login.enter_str") }}</p>
              <el-button
                round
                plain
                class="switch-btn signup-btn"
                @click="mode = 'register'"
                >{{ $t("login.signup") }}</el-button
              >
            </div>
          </div>
        </template>

        <!-- ==================== 注册面板 (当 mode 为 'register' 时显示) ==================== -->
        <template v-else-if="mode === 'register'">
          <!-- 左侧：欢迎与登录入口 -->
          <div class="welcome-panel">
            <div class="yanding-logo on-blue">
              <img src="@/assets/yanding-logo-white.png" alt="YANDING Logo" />
            </div>
            <div class="welcome-content">
              <h2 class="welcome-title">
                {{ $t("register.welcome_title") }}
              </h2>
              <p class="welcome-text">{{ $t("register.welcome_text") }}</p>
              <el-button
                round
                plain
                class="switch-btn signup-btn"
                @click="mode = 'login'"
                >{{ $t("login.signin") }}</el-button
              >
            </div>
          </div>
          <!-- 右侧：注册表单 -->
          <div class="form-panel">
            <i
              class="el-icon-close close-btn on-white"
              @click="handleClose"
            ></i>
            <div class="form-wrapper">
              <h2 class="title">{{ $t("register.title") }}</h2>
              <el-form
                ref="registerForm"
                :model="registerForm"
                :rules="registerRules"
                class="register-form"
                @submit.native.prevent="handleRegister"
              >
                <el-form-item prop="name">
                  <el-input
                    v-model="registerForm.name"
                    :placeholder="$t('register.name')"
                    autocomplete="off"
                    prefix-icon="el-icon-user"
                    class="custom-input"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="email">
                  <el-input
                    v-model="registerForm.email"
                    :placeholder="$t('register.email')"
                    autocomplete="off"
                    prefix-icon="el-icon-message"
                    class="custom-input"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="city">
                  <el-input
                    v-model="registerForm.city"
                    :placeholder="$t('register.city')"
                    autocomplete="off"
                    prefix-icon="el-icon-office-building"
                    class="custom-input"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  prop="password"
                  :class="{ 'is-error': !!registerserverErrorMessage }"
                >
                  <el-input
                    v-model="registerForm.password"
                    type="password"
                    :placeholder="$t('login.pwd')"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                    class="custom-input"
                    @input="clearRegisterPasswordError"
                  ></el-input>
                  <div
                    v-if="registerserverErrorMessage"
                    class="el-form-item__error manual-error"
                  >
                    {{ registerserverErrorMessage }}
                  </div>
                </el-form-item>

                <el-form-item prop="confirmPassword">
                  <el-input
                    v-model="registerForm.confirmPassword"
                    type="password"
                    :placeholder="$t('register.confirm_pwd')"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                    class="custom-input"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="isChineseLocale" prop="phone">
                  <el-input
                    v-model="registerForm.phone"
                    :placeholder="$t('register.phone')"
                    autocomplete="off"
                    prefix-icon="el-icon-mobile-phone"
                    class="custom-input"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="verificationCode">
                  <div class="input-with-button">
                    <el-input
                      v-model="registerForm.verificationCode"
                      :placeholder="$t('register.verify_code')"
                      autocomplete="off"
                      prefix-icon="el-icon-key"
                      class="custom-input verification-code-input"
                      maxlength="6"
                      @input="handleVerificationCodeInput('register')"
                    ></el-input>
                    <el-button
                      type="text"
                      class="send-code-btn"
                      @click="sendCode"
                      :disabled="
                        registerState.isCountingDown ||
                        registerState.isSendingCode
                      "
                      >{{ registerSendCodeText }}</el-button
                    >
                  </div>
                </el-form-item>

                <!-- --- 隐私协议 Checkbox --- -->
                <el-form-item prop="agreeToPolicy" class="policy-item">
                  <el-checkbox v-model="registerForm.agreeToPolicy">
                    <span>{{ $t("register.agree") }}</span>
                    <a
                      href="#"
                      class="policy-link"
                      @click.prevent="openPrivacyPolicy"
                    >
                      {{ $t("register.privacyPolicy") }}
                    </a>
                  </el-checkbox>
                </el-form-item>
              </el-form>
              <el-button
                type="primary"
                class="action-btn signin-btn"
                @click="handleRegister"
                :loading="isRegistering"
                >{{ $t("register.signup") }}</el-button
              >
            </div>
          </div>
        </template>
        <!-- ==================== 忘记密码面板 (当 mode 为 'forgotPassword' 时显示) ==================== -->
        <template v-else-if="mode === 'forgotPassword'">
          <div class="form-panel forgot-password-panel">
            <div class="yanding-logo">
              <img src="@/assets/yanding-logo.png" alt="YANDING Logo" />
            </div>
            <i
              class="el-icon-close close-btn on-white"
              @click="handleClose"
            ></i>
            <div class="form-wrapper">
              <h2 class="title">{{ $t("forgotPassword.title") }}</h2>
              <p class="subtitle">{{ $t("forgotPassword.subtitle") }}</p>
              <el-form
                ref="forgotPasswordForm"
                :model="forgotPasswordForm"
                :rules="forgotPasswordRules"
                class="forgot-password-form"
                @submit.native.prevent="handleForgotPassword"
              >
                <el-form-item v-if="isChineseLocale" prop="phone">
                  <el-input
                    v-model="forgotPasswordForm.phone"
                    :placeholder="$t('register.phone')"
                    autocomplete="off"
                    prefix-icon="el-icon-mobile-phone"
                    class="custom-input"
                  ></el-input>
                </el-form-item>

                <el-form-item v-else prop="email">
                  <el-input
                    v-model="forgotPasswordForm.email"
                    :placeholder="$t('register.email')"
                    autocomplete="off"
                    prefix-icon="el-icon-message"
                    class="custom-input"
                  ></el-input>
                </el-form-item>

                <!-- 验证码 -->
                <el-form-item prop="verificationCode">
                  <div class="input-with-button">
                    <el-input
                      v-model="forgotPasswordForm.verificationCode"
                      :placeholder="$t('register.verify_code')"
                      autocomplete="off"
                      prefix-icon="el-icon-key"
                      class="custom-input verification-code-input"
                      maxlength="6"
                      @input="handleVerificationCodeInput('forgotPassword')"
                    ></el-input>
                    <el-button
                      type="text"
                      class="send-code-btn"
                      @click="sendCode"
                      :disabled="
                        forgotPasswordState.isCountingDown ||
                        forgotPasswordState.isSendingCode
                      "
                      >{{ forgotPasswordSendCodeText }}</el-button
                    >
                  </div>
                </el-form-item>

                <!-- 新密码 -->
                <el-form-item
                  prop="newPassword"
                  :class="{ 'is-error': !!ForgotPasswordserverErrorMessage }"
                >
                  <el-input
                    v-model="forgotPasswordForm.newPassword"
                    type="password"
                    :placeholder="$t('forgotPassword.new_pwd')"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                    class="custom-input"
                    @input="clearForgotPasswordError"
                  ></el-input>
                  <div
                    v-if="ForgotPasswordserverErrorMessage"
                    class="el-form-item__error manual-error"
                  >
                    {{ ForgotPasswordserverErrorMessage }}
                  </div>
                </el-form-item>

                <!-- 确认密码 -->
                <el-form-item prop="confirmPassword">
                  <el-input
                    v-model="forgotPasswordForm.confirmPassword"
                    type="password"
                    :placeholder="$t('register.confirm_pwd')"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                    class="custom-input"
                  ></el-input>
                </el-form-item>
              </el-form>
              <el-button
                type="primary"
                class="action-btn reset-btn"
                @click="handleForgotPassword"
                :loading="isResettingPassword"
                >{{ $t("forgotPassword.reset_btn") }}</el-button
              >
              <div class="back-to-signin-wrapper">
                <a
                  href="#"
                  class="back-to-signin"
                  @click.prevent="mode = 'login'"
                  >{{ $t("forgotPassword.back_to_signin") }}</a
                >
              </div>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </el-dialog>
</template>

<script>
import {
  sendVerificationCode,
  registerUser,
  resetPassword,
  loginUser,
} from "@/api";
export default {
  name: "AuthModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 注册表单的确认密码校验
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("validation.confirmPwdRequired")));
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,12}$/.test(value)
      ) {
        callback(new Error(this.$t("validation.passwordInvalid")));
      } else if (value !== this.registerForm.password) {
        callback(new Error(this.$t("validation.passwordsDontMatch")));
      } else {
        callback();
      }
    };

    // 忘记密码表单的确认密码校验
    const validateForgotPasswordConfirm = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("validation.confirmPwdRequired")));
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,12}$/.test(value)
      ) {
        callback(new Error(this.$t("validation.passwordInvalid")));
      } else if (value !== this.forgotPasswordForm.newPassword) {
        callback(new Error(this.$t("validation.passwordsDontMatch")));
      } else {
        callback();
      }
    };

    return {
      mode: "login", // 'login', 'register', 'forgotPassword'
      loginForm: { phone: "", password: "" },
      serverErrorMessage: "",
      registerserverErrorMessage: "",
      ForgotPasswordserverErrorMessage: "",
      registerForm: {
        name: "",
        email: "",
        city: "",
        password: "",
        confirmPassword: "",
        phone: "",
        verificationCode: "",
        agreeToPolicy: false,
      },
      forgotPasswordForm: {
        phone: "",
        email: "",
        verificationCode: "",
        newPassword: "",
        confirmPassword: "",
      },
      validatePass,
      validateForgotPasswordConfirm,
      loginRules: {},
      registerState: {
        isCountingDown: false,
        countdown: 60,
        timer: null,
        isSendingCode: false,
      },
      forgotPasswordState: {
        isCountingDown: false,
        countdown: 60,
        timer: null,
        isSendingCode: false,
      },
      isRegistering: false,
      isResettingPassword: false,
      isLoggingIn: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    isChineseLocale() {
      const controlLang = this.$store.getters.controlLang;
      return controlLang && controlLang === "zh";
    },
    registerSendCodeText() {
      return this.registerState.isCountingDown
        ? `${this.registerState.countdown} s`
        : this.$t("register.send_code");
    },
    forgotPasswordSendCodeText() {
      return this.forgotPasswordState.isCountingDown
        ? `${this.forgotPasswordState.countdown} s`
        : this.$t("register.send_code");
    },
    loginRulesComputed() {
      const phoneRules = [
        {
          required: true,
          message: this.isChineseLocale
            ? this.$t("validation.phoneRequired")
            : this.$t("validation.emailRequired"),
          trigger: "blur",
        },
      ];

      // 根据控制语言添加格式验证
      if (this.isChineseLocale) {
        // 中文环境：添加手机号格式验证
        phoneRules.push({
          pattern: /^1[3-9]\d{9}$/,
          message: this.$t("validation.phoneInvalid"),
          trigger: ["blur", "change"],
        });
      } else {
        // 海外环境：添加邮箱格式验证
        phoneRules.push({
          type: "email",
          message: this.$t("validation.emailInvalid"),
          trigger: ["blur", "change"],
        });
      }

      return {
        phone: phoneRules,
        password: [
          {
            required: true,
            message: this.$t("validation.passwordRequired"),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,12}$/,
            message: this.$t("validation.passwordInvalid"),
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    registerRules() {
      const rules = {
        name: [
          {
            required: true,
            message: this.$t("validation.nameRequired"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("validation.emailRequired"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("validation.emailInvalid"),
            trigger: ["blur", "change"],
          },
        ],
        city: [
          {
            required: true,
            message: this.$t("validation.cityRequired"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validation.passwordRequired"),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,12}$/,
            message: this.$t("validation.passwordInvalid"),
            trigger: ["blur", "change"],
          },
        ],
        confirmPassword: [
          { validator: this.validatePass, trigger: ["blur", "change"] },
        ],
        verificationCode: [
          {
            required: true,
            message: this.$t("validation.codeRequired"),
            trigger: "blur",
          },
          {
            pattern: /^\d{6}$/,
            message: this.$t("validation.codeInvalid"),
            trigger: ["blur", "change"],
          },
        ],
        // --- 协议勾选的校验规则 ---
        agreeToPolicy: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                callback();
              } else {
                callback(new Error(this.$t("validation.agreeRequired")));
              }
            },
            trigger: "change",
          },
        ],
      };

      if (this.isChineseLocale) {
        rules.phone = [
          {
            required: true,
            message: this.$t("validation.phone1Required"),
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t("validation.phoneInvalid"),
            trigger: ["blur", "change"],
          },
        ];
      }
      return rules;
    },
    forgotPasswordRules() {
      const rules = {
        verificationCode: [
          {
            required: true,
            message: this.$t("validation.codeRequired"),
            trigger: "blur",
          },
          {
            pattern: /^\d{6}$/,
            message: this.$t("validation.codeInvalid"),
            trigger: ["blur", "change"],
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("validation.passwordRequired"),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{6,12}$/,
            message: this.$t("validation.passwordInvalid"),
            trigger: ["blur", "change"],
          },
        ],
        confirmPassword: [
          {
            validator: this.validateForgotPasswordConfirm,
            trigger: ["blur", "change"],
          },
        ],
      };

      if (this.isChineseLocale) {
        rules.phone = [
          {
            required: true,
            message: this.$t("validation.phone1Required"),
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t("validation.phoneInvalid"),
            trigger: ["blur", "change"],
          },
        ];
      } else {
        rules.email = [
          {
            required: true,
            message: this.$t("validation.emailRequired"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("validation.emailInvalid"),
            trigger: ["blur", "change"],
          },
        ];
      }
      return rules;
    },
  },
  watch: {
    "$i18n.locale"() {
      this.setLoginValidationRules();
    },
  },
  created() {
    this.setLoginValidationRules();
  },
  methods: {
    /**
     * 根据当前语言打开对应的隐私协议链接
     */
    openPrivacyPolicy() {
      const lang = this.$i18n.locale;
      const apiUrl = process.env.VUE_APP_API_URL;
      let policyPath = "";

      switch (lang) {
        case "zh":
          policyPath = `${apiUrl}/api/v1/static/pdf/上海研鼎信息技术有限公司隐私政策.pdf`;
          break;
        case "ja":
          policyPath = `${apiUrl}/api/v1/static/pdf/プライバシーポリシー.pdf`;
          break;
        case "en":
        default:
          policyPath = `${apiUrl}/api/v1/static/pdf/Shanghai Yanding Information Technology Co., Ltd. Privacy Policy.pdf`;
          break;
      }

      window.open(policyPath, "_blank");
    },
    initializeForm() {
      this.loginForm = { phone: "", password: "" };
      this.registerForm = {
        name: "",
        email: "",
        city: "",
        password: "",
        confirmPassword: "",
        phone: "",
        verificationCode: "",
        agreeToPolicy: false,
      };
      this.forgotPasswordForm = {
        phone: "",
        email: "",
        verificationCode: "",
        newPassword: "",
        confirmPassword: "",
      };

      this.mode = "login";

      this.serverErrorMessage = "";
      this.registerserverErrorMessage = "";
      this.ForgotPasswordserverErrorMessage = "";

      if (this.registerState.timer) {
        clearInterval(this.registerState.timer);
      }
      this.registerState = {
        isCountingDown: false,
        countdown: 60,
        timer: null,
        isSendingCode: false,
      };

      if (this.forgotPasswordState.timer) {
        clearInterval(this.forgotPasswordState.timer);
      }
      this.forgotPasswordState = {
        isCountingDown: false,
        countdown: 60,
        timer: null,
        isSendingCode: false,
      };

      this.isRegistering = false;
      this.isResettingPassword = false;

      this.$nextTick(() => {
        if (this.$refs.loginForm) this.$refs.loginForm.clearValidate();
        if (this.$refs.registerForm) this.$refs.registerForm.clearValidate();
        if (this.$refs.forgotPasswordForm)
          this.$refs.forgotPasswordForm.clearValidate();
      });
    },
    setLoginValidationRules() {
      this.loginRules = this.loginRulesComputed;
    },
    async handleLogin() {
      this.serverErrorMessage = "";

      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const payload = {
            password: this.loginForm.password,
          };
          if (this.isChineseLocale) {
            payload.phone = this.loginForm.phone;
          } else {
            payload.email = this.loginForm.phone;
          }

          this.isLoggingIn = true;
          try {
            const response = await loginUser(payload);

            if (response && response.data) {
              this.$emit("login-success", response.data);
            }

            // this.$notify.success({
            //   title: this.$t("success.successTitle"),
            //   message: this.$t("success.loginSuccess"),
            // });

            this.handleClose();
          } catch (error) {
            console.log(
              "Login failed, error was handled by interceptor.",
              error
            );
          } finally {
            this.isLoggingIn = false;
          }
        } else {
          console.log("Login form validation failed!");
          return false;
        }
      });
    },
    clearPasswordError() {
      if (this.serverErrorMessage) {
        this.serverErrorMessage = "";
      }
    },
    async handleRegister() {
      this.registerserverErrorMessage = "";
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          const payload = {
            username: this.registerForm.name,
            email: this.registerForm.email,
            password: this.registerForm.password,
            city: this.registerForm.city,
            verification_code: this.registerForm.verificationCode,
            phone: this.isChineseLocale ? this.registerForm.phone : "",
          };

          this.isRegistering = true;
          try {
            await registerUser(payload);
            this.$notify.success({
              title: this.$t("success.successTitle"),
              message: this.$t("success.registerSuccess"),
            });
            this.$refs.registerForm.resetFields();
            this.mode = "login";
          } catch (error) {
            console.log("请求失败，但错误已被捕获，页面不会崩溃。", error);
          } finally {
            this.isRegistering = false;
          }
        } else {
          console.log("Register form validation failed!");
          return false;
        }
      });
    },
    clearRegisterPasswordError() {
      if (this.registerserverErrorMessage) {
        this.registerserverErrorMessage = "";
      }
    },

    async handleForgotPassword() {
      this.ForgotPasswordserverErrorMessage = "";
      this.$refs.forgotPasswordForm.validate(async (valid) => {
        if (valid) {
          const payload = {
            verification_code: this.forgotPasswordForm.verificationCode,
            new_password: this.forgotPasswordForm.newPassword,
          };
          if (this.isChineseLocale) {
            payload.phone = this.forgotPasswordForm.phone;
          } else {
            payload.email = this.forgotPasswordForm.email;
          }

          this.isResettingPassword = true;
          try {
            await resetPassword(payload);

            this.$notify.success({
              title: this.$t("success.successTitle"),
              message: this.$t("success.passwordResetSuccess"),
            });

            localStorage.removeItem("token");
            localStorage.removeItem("user_info");

            this.$refs.forgotPasswordForm.resetFields();
            this.mode = "login";
          } catch (error) {
            console.log("请求失败，但错误已被捕获，页面不会崩溃。", error);
          } finally {
            this.isResettingPassword = false;
          }
        } else {
          console.log("Forgot password form validation failed!");
          return false;
        }
      });
    },

    clearForgotPasswordError() {
      if (this.ForgotPasswordserverErrorMessage) {
        this.ForgotPasswordserverErrorMessage = "";
      }
    },
    /**
     * 处理验证码输入，只允许输入数字
     * @param {string} mode - 'register' 或 'forgotPassword'
     */
    handleVerificationCodeInput(mode) {
      if (mode === "register") {
        // 只保留数字
        this.registerForm.verificationCode =
          this.registerForm.verificationCode.replace(/\D/g, "");
      } else if (mode === "forgotPassword") {
        // 只保留数字
        this.forgotPasswordForm.verificationCode =
          this.forgotPasswordForm.verificationCode.replace(/\D/g, "");
      }
    },
    async sendCode() {
      const isRegisterMode = this.mode === "register";
      const currentState = isRegisterMode
        ? this.registerState
        : this.forgotPasswordState;

      if (currentState.isCountingDown || currentState.isSendingCode) return;

      const formRef = isRegisterMode
        ? this.$refs.registerForm
        : this.$refs.forgotPasswordForm;
      const fieldName = this.isChineseLocale ? "phone" : "email";

      const validateField = () => {
        return new Promise((resolve, reject) => {
          formRef.validateField(fieldName, (errorMessage) => {
            if (errorMessage) {
              reject(new Error(errorMessage));
            } else {
              resolve();
            }
          });
        });
      };

      try {
        await validateField();
      } catch (error) {
        console.warn("Validation failed:", error.message);
        return;
      }

      const fieldValue = isRegisterMode
        ? this.registerForm[fieldName]
        : this.forgotPasswordForm[fieldName];

      const payload = {
        [fieldName]: fieldValue,
      };

      if (isRegisterMode) {
        payload.purpose = "register";
        // 注册时添加 username 字段
        payload.username = this.registerForm.name;
      } else {
        payload.purpose = "reset_password";
      }

      currentState.isSendingCode = true;
      try {
        await sendVerificationCode(payload);

        this.$notify.success({
          title: this.$t("success.successTitle"),
          message: this.$t("success.codeSentSuccess"),
        });

        currentState.isCountingDown = true;
        currentState.timer = setInterval(() => {
          if (currentState.countdown > 1) {
            currentState.countdown--;
          } else {
            clearInterval(currentState.timer);
            currentState.timer = null;
            currentState.isCountingDown = false;
            currentState.countdown = 60;
          }
        }, 1000);
      } catch (error) {
        console.log("请求失败，但错误已被捕获，页面不会崩溃。", error);
      } finally {
        currentState.isSendingCode = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep .auth-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  margin-top: 8vh !important;
  transition: width 0.3s ease;
}
::v-deep .auth-dialog.forgot-password-dialog {
  width: 500px !important;
}

::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  padding: 0;
}

.auth-container {
  display: flex;
  min-height: 555px;
}

.form-panel {
  width: 60%;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  position: relative;
}
.form-wrapper {
  width: 100%;
  max-width: 400px;
  text-align: center;
}
.title {
  font-size: 30px;
  font-weight: bold;
  color: #00a0e9;
  text-align: center;
}
.yanding-logo {
  position: absolute;
  top: 20px;
  left: 25px;
}
.yanding-logo img {
  height: 50px;
}
.yanding-logo.on-blue {
  position: absolute;
  top: 20px;
  left: 25px;
}
.action-btn {
  padding: 12px 45px;
  font-weight: bold;
  border-radius: 24px;
  letter-spacing: 1px;
  margin-top: 2%;
}
.signin-btn {
  width: auto;
}

.welcome-panel {
  width: 45%;
  background-color: #00a0e9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  padding: 40px;
  box-sizing: border-box;
}
.welcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s, transform 0.3s;
}
.close-btn:hover {
  opacity: 1;
  transform: rotate(90deg);
}
.close-btn.on-white {
  color: #909399;
}
.welcome-title {
  font-size: 35px;
  font-weight: bold;
  margin-bottom: 15px;
}
.welcome-text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
  max-width: 280px;
}
.switch-btn.signup-btn {
  background: transparent;
  color: #fff;
  border-color: #fff;
  font-weight: bold;
  padding: 12px 45px;
  transition: all 0.3s;
}
.switch-btn.signup-btn:hover {
  background: #fff;
  color: #00a0e9;
}

.login-form {
  max-width: 320px;
  margin: 0 auto;
}
.login-form .el-form-item {
  margin-bottom: 33px;
}
.forgot-password-wrapper {
  margin-top: 12%;
  margin-bottom: 25px;
}
.forgot-password {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.3s;
  display: inline-block;
}
.forgot-password:hover {
  color: #00a0e9;
}

.register-form .el-form-item {
  margin-bottom: 33px;
}

::v-deep .custom-input .el-input__inner {
  height: 48px;
  line-height: 48px;
  background-color: #f7f8fa;
  border: 1px solid #f7f8fa;
  border-radius: 8px;
  font-size: 14px;
}
::v-deep .custom-input .el-input__inner:focus {
  border-color: #00a0e9;
  background-color: #fff;
}
::v-deep .custom-input .el-input__prefix {
  display: flex;
  align-items: center;
  left: 15px;
}
::v-deep .custom-input .el-input__icon {
  width: auto;
  font-size: 18px;
  color: #c0c4cc;
}
::v-deep .register-form .el-input__inner {
  padding-left: 45px;
}
::v-deep .login-form .el-input__inner {
  padding-left: 45px;
}
::v-deep .forgot-password-form .el-input__inner {
  padding-left: 45px;
}

.input-with-button {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #f7f8fa;
  border: 1px solid #f7f8fa;
  border-radius: 8px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  overflow: hidden;
}

::v-deep .input-with-button .verification-code-input .el-input__inner {
  border: none;
  background-color: transparent;
  border-radius: 8px 0 0 8px;
  height: 46px;
  line-height: 46px;
}

.input-with-button .send-code-btn {
  flex-shrink: 0;
  background: transparent;
  color: #00a0e9;
  font-weight: 600;
  padding: 0;
  border-left: 1px solid #e0e0e0;
  border-radius: 0;
  height: 24px;
  line-height: 24px;
  width: 110px;
  text-align: center;
}
.input-with-button .send-code-btn:hover {
  opacity: 0.8;
}

.input-with-button .send-code-btn[disabled] {
  color: #00a0e9;
  cursor: not-allowed;
}

.input-with-button:focus-within {
  border-color: #00a0e9;
  background-color: #fff;
}

::v-deep .el-input-group__append {
  background-color: #f7f8fa;
  border: 1px solid #f7f8fa;
  border-left: none;
  border-radius: 0 8px 8px 0;
}

::v-deep .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
}

::v-deep .el-form-item.is-error .input-with-button {
  border-color: #f56c6c;
}

::v-deep .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  text-align: left;
  padding-top: 4px;
}
.manual-error {
  position: absolute;
  left: 0;
  top: 100%;
}

.forgot-password-panel {
  width: 100%;
}
.yanding-logo-center {
  margin-bottom: 20px;
}
.yanding-logo-center img {
  height: 50px;
}
.forgot-password-panel .title {
  margin-bottom: 15px;
  margin-top: 66px;
}
.subtitle {
  color: #909399;
  font-size: 14px;
  margin-bottom: 35px;
}
.forgot-password-form .el-form-item {
  margin-bottom: 33px;
}
::v-deep .forgot-password-form .el-input-group__prepend {
  background-color: #f7f8fa;
  border: 1px solid #f7f8fa;
  border-right: none;
  color: #909399;
  padding: 0 15px;
}
::v-deep .forgot-password-form .el-input--prepend .el-input__inner {
  padding-left: 15px;
}
.reset-btn {
  margin-top: 10px;
}
.back-to-signin-wrapper {
  margin-top: 25px;
}

.back-to-signin {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.3s;
}
.back-to-signin:hover {
  color: #00a0e9;
}

.policy-item {
  margin-bottom: 20px !important;
  text-align: left;
}

.policy-item ::v-deep .el-checkbox__label {
  padding-left: 5px;
  font-size: 12px;
  color: #606266;
}

.policy-link {
  color: #00a0e9;
  text-decoration: none;
  margin-left: 2px;
}

.policy-link:hover {
  text-decoration: underline;
}

.policy-item ::v-deep .el-checkbox__inner {
  top: 1px;
}

@media (max-width: 850px) {
  ::v-deep .auth-dialog {
    width: 90vw !important;
    max-width: 450px;
  }
  ::v-deep .auth-dialog.forgot-password-dialog {
    width: 90vw !important;
  }
  .auth-container {
    flex-direction: column;
  }
  .auth-container.register-mode {
    flex-direction: column-reverse;
  }
  .form-panel,
  .welcome-panel {
    width: 100%;
  }
  .welcome-panel {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .yanding-logo,
  .yanding-logo.on-blue {
    top: 20px;
    left: 20px;
  }
  .yanding-logo img,
  .yanding-logo.on-blue img {
    height: 40px;
  }
  .title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .close-btn {
    display: none;
  }
  .forgot-password {
    margin-top: 18%;
  }
}
</style>
